












import { Component, Vue } from 'vue-property-decorator'

import ApplicationHeader from '@/components/layout/ApplicationHeader.vue'
import ApplicationFooter from '@/components/layout/ApplicationFooter.vue'
import BaseConsent from '@/components/common/BaseConsent.vue'

@Component( {
    components: {
        'application-header': ApplicationHeader,
        'application-footer': ApplicationFooter,
        'oe-base-consent': BaseConsent
    }
} )
export default class App extends Vue {
    appLoaded = false

    mounted() {
        const whereClause = [['published', '==', true]]
        const orderByClause = ['created_at']

        Promise.all([
            this.$store.dispatch( 'associationsModule/openDBChannel', { clauses: { whereClause, orderByClause } }  ),
            this.$store.dispatch( 'commentsModule/openDBChannel', { clauses: { whereClause } } ),
            this.$store.dispatch( 'imagesModule/openDBChannel' ),
            this.$store.dispatch( 'usersModule/openDBChannel' )
        ] )
        .then( () => {
            this.appLoaded = true
            this.$store.dispatch( 'usersModule/initUser' )
        } )
        .catch( error => console.error( error ) )
    }
}

